<template>
  <div id="wrapper">
    <LazyGlobalLoading v-if="loadingStore.show"/>
    <template v-else>
      <section class="assessmentHeader">
        <LazyLearningLevelAssessmentHeaderTop :track-title="assessmentStore.trackInfo.title"/>
        <LazyLearningLevelAssessmentHeaderBottom
            :is-result="true"
            :level-assessment="levelAssessment"
            :level-assessment-result-list="levelAssessmentData"
            @on-click-submit-date="methods.onSelectDateOf"
        />
      </section>
      <section class="assessmentMiddle">
        <div class="testWrap scrollBar">
          <div class="testResultWrap">
            <div class="testResultBanner">
              <LazyLearningLevelAssessmentResultBanner
                  :is-completed="isCompleted"
              />
              <LazyLearningLevelAssessmentResultReviewAnswers
                  :key="reviewAnswersKey"
                  :selected-submit="currentSubmit.resultList"
                  @on-click-question="methods.onClickQuestion"
              />
            </div>
            <LazyLearningLevelAssessmentResultReviewAnswersDetail
                :key="currentQuestionIndex"
                :level-assessment-result="currentSubmit.resultList[currentQuestionIndex]"
            />
          </div>
        </div>
      </section>
      <LazyLearningLevelAssessmentFooter />
    </template>
  </div>
</template>

<script setup lang="ts">
import {
  LazyGlobalLoading,
  LazyLearningLevelAssessmentFooter,
  LazyLearningLevelAssessmentHeaderBottom,
  LazyLearningLevelAssessmentHeaderTop,
  LazyLearningLevelAssessmentResultBanner,
  LazyLearningLevelAssessmentResultReviewAnswers,
  LazyLearningLevelAssessmentResultReviewAnswersDetail
} from '#components';
import {computed, onMounted, ref, useI18n, useRoute} from "#imports";
import {useLevelAssessmentService} from "~/composables/service/useLevelAssessmentService";
import {useLearningStore} from "~/store/learning/learningStore";
import {useLearningAssessmentStore} from "~/store/learning/assessment/learningAssessmentStore";
import {LevelAssessmentResultListModel} from "~~/package/mapper/levelAssessment/model/LevelAssessmentResultListModel";
import {useLoadingStore} from '~/store/loading/loadingStore';
import {useGenericDialog} from "~/composables/useGenericDialog";

const { t } = useI18n();
const {locale} = useI18n();
const route = useRoute();
const learningStore = useLearningStore();
    const assessmentStore = useLearningAssessmentStore();
const levelAssessmentData = ref<LevelAssessmentResultListModel[]>([]);
const loadingStore = useLoadingStore();
const { openWrongApproachAlert } = useGenericDialog();

const currentSubmit = ref(new LevelAssessmentResultListModel());
const currentQuestionIndex = ref(0);
const reviewAnswersKey = ref(0);

const levelAssessment = computed(() =>
    `${assessmentStore.trackInfo.trackLevelTitle} ${t('skillCertify-assessment', 1)}`
);
const isCompleted = computed(() =>
    levelAssessmentData.value.some(result => result.isPass)
);

onBeforeMount(() => {
  loadingStore.openLoading("");
})

onMounted(() => {
  if (route.params.levelId !== undefined)
    methods.getTrackData(parseInt(route.params.levelId as string));
});

const methods = {
  getTrackData(id: number) {
    useLevelAssessmentService().getLevelAssessmentInfo(id, false)
        .then((levelAssessment) => {
          learningStore.updateTrackLevelInfo(levelAssessment, id)
          methods.getLevelAssessmentResult(id);
        }).catch(() => {
      methods.openFailPopup();
    });
  },
  getLevelAssessmentResult(id: number) {
    useLevelAssessmentService().getLevelAssessmentResultList(id)
        .then(levelAssessment => {
          if (levelAssessment.length > 0) {
            levelAssessmentData.value = levelAssessment;
            currentSubmit.value = levelAssessmentData.value[0];
            loadingStore.closeLoading();
          } else {
            methods.openFailPopup();
          }
        });
  },
  onSelectDateOf(submit: LevelAssessmentResultListModel) {
    currentSubmit.value = submit;
    currentQuestionIndex.value = 0;
    reviewAnswersKey.value++;
  },
  openFailPopup() {
    openWrongApproachAlert();
  },
  onClickQuestion(index: number) {
    currentQuestionIndex.value = index;
  }
};
</script>
